import React from "react";
import DashBoard from "./Components/index";
import useFilter from "Hooks/useFilter";
import queryString from "query-string";
import { fromMonthly, toMonthly } from "fuction/date";
import { withRouter } from "react-router";
import { message } from "constants/message";
import useAuth from "Hooks/useAuth";

function Page(props) {
  const filter = useFilter();
  const auth = useAuth();
  const messages = message();
  const fromDate = fromMonthly(filter.state.filteredDateFrom);
  const toDate = toMonthly(filter.state.filteredDateTo);
  const { status } = queryString.parse(props.location.search);
  const activeMediaGroup = auth.state.activeMediaGroup;
  const onClickLineChart = (date, type = null) => {
    props.history.push(`/media/dashboard/daily?activeMediaGroup=${activeMediaGroup}&date=${date}&type=${type}`);
  };
  const onClickListButton = (date, type = null) => {
    props.history.push(`/media/dashboard/details?activeMediaGroup=${activeMediaGroup}&date=${date}&interval=monthly&type=${type}`);
  };

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Media - ダッシュボード";

    switch (status) {
      case "201":
        alert(messages.dashboard.passwordReset);
        break;
      default:
        break;
    }
  }, []);

  return (
    <DashBoard
      fromDate={fromDate}
      toDate={toDate}
      target="monthly"
      unit="date"
      onClickLineChart={onClickLineChart}
      onClickListButton={onClickListButton}
    />
  );
}

export default withRouter(Page);
